import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=4c6f2dd5&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=4c6f2dd5&prod&lang=scss&scoped=true"
import style1 from "./Result.vue?vue&type=style&index=1&id=4c6f2dd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f2dd5",
  null
  
)

export default component.exports